import filterFormErrors from '@anm/helpers/form/filterFormErrors';
import { Config as FinalFormConfig } from 'final-form';
import { FC } from 'react';
import { Form, FormRenderProps } from 'react-final-form';

import SubmitEditCardBlock, {
  SubmitEditCardBlockProps
} from '../SubmitEditCardBlock';

export type EditCardFormFields = {
  cvc: number;
  number: string;
  address_zip: string;
  expiry_year: number;
  expiry_month: number;
};

export type EditCardFormProps = FinalFormConfig<EditCardFormFields> &
  Omit<SubmitEditCardBlockProps, 'formErrors' | 'onSubmit'>;

const renderForm = (props: EditCardFormProps) => ({
  handleSubmit,
  errors,
  touched
}: FormRenderProps<EditCardFormFields>) => {
  return (
    <SubmitEditCardBlock
      {...props}
      formErrors={filterFormErrors(errors, touched)}
      onSubmit={handleSubmit}
    />
  );
};

const EditCardForm: FC<EditCardFormProps> = props => (
  <Form render={renderForm(props)} {...props} />
);

export default EditCardForm;
